/** Must stay in sync with backend/src/lib/upload-limits.js */
export const MAX_UPLOAD_BYTES = 50 * 1024 * 1024;
export const MAX_UPLOAD_MB = 50;
